var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"align-v":"center"}},[_c('b-img',{attrs:{"center":"","fluid":"","src":require('../assets/_LoadingAnim.gif'),"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }